module.exports = __webpack_public_path__ + "static/media/Santa.df2e066e.jpg";